// extracted by mini-css-extract-plugin
module.exports = {"Popup":"popUp-module--Popup--3XWbm","PopupContent":"popUp-module--PopupContent--7hrp8","PopupActive":"popUp-module--PopupActive--2K7T-"};